// extracted by mini-css-extract-plugin
export default {"programList":"programList__FsZC-"};